export type UnifiedProfileSubot = {
  id: number | string
  class: string
}

export enum CollectingActionType {
  SUBOT = 'subot',
  HEALTHTOOL = 'health_tool',
}

export type CollingActionProps = {
  id: number | string
  name: CollectingActionType
}

export type CollingFieldProps = {
  id: number
  name: string
  actions: CollingActionProps[]
}
